import React from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { Route } from 'react-router-dom'
import { Login } from './Login';
import { OrderList } from './OrderList';
import { MainData } from './MainData'

const Container = styled.section`
`;

const PanelContainer = styled.section`
    width: 100%;
    // max-width:1920px;
    padding: 5rem 2rem;
    
    display: flex;
    flex-direction: column;
    align-items: center;
`

const Panel = () => {
    return (
        <PanelContainer>
            <Route exact path='/admin/main-data' component={ MainData } />
            <Route exact path='/admin/orders' component={ OrderList } />
        </PanelContainer>
    )
}

export const AdminPanel = () => {

    const loggedIn = useSelector(state => state.firebase.auth.isEmpty === false)

    return (
        <Container>
            { loggedIn ? <Panel /> : <Login /> }
        </Container>
    )
}
